import React, { useState } from "react";
import DomainSeoHelmet from "../agentic/DomainSeoHelmet";
import DomainHiddenSeoContent from "../agentic/DomainHiddenSeoContent";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "../agentic/domainUseCaseLayout";
import UseCaseIndexGrid from "../agentic/UseCaseIndexGrid";
import RpaProcessFlow from "./RpaProcessFlow";
import {
  EDUCATION_DOMAIN_INTRO,
  EDUCATION_GROUPS,
  EDUCATION_USE_CASES_SEO,
  EDUCATION_DOMAIN_FAQS,
  EDUCATION_ITEM_LIST_JSONLD,
  EDUCATION_BREADCRUMB_JSONLD,
  EDUCATION_WEBPAGE_JSONLD,
  EDUCATION_FAQ_JSONLD,
} from "../../data/rpa/education-domainUseCases";

function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<RpaProcessFlow useCase={useCase} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = EDUCATION_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function EducationRpaDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups =
    activeFilter === "all"
      ? EDUCATION_GROUPS
      : EDUCATION_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={EDUCATION_DOMAIN_INTRO}
        domainSlug="education-domain"
        basePath="/rpa-use-cases"
        useCaseCount={EDUCATION_USE_CASES_SEO.length}
        groupCount={EDUCATION_GROUPS.length}
        itemListJsonLd={EDUCATION_ITEM_LIST_JSONLD}
        faqJsonLd={EDUCATION_FAQ_JSONLD}
        breadcrumbJsonLd={EDUCATION_BREADCRUMB_JSONLD}
        webPageJsonLd={EDUCATION_WEBPAGE_JSONLD}
        keywords="Education automation, document AI + RPA, workflow automation, robotic process automation India UAE KSA UK USA"
        sectionLabel=""
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{EDUCATION_DOMAIN_INTRO.title}</h1>
          {EDUCATION_DOMAIN_INTRO.content ? <p>{EDUCATION_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid
        useCases={EDUCATION_USE_CASES_SEO}
        groups={EDUCATION_GROUPS}
        heading="Education Use Cases"
        onFilterChange={setActiveFilter}
      />
      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={EDUCATION_DOMAIN_INTRO.title}
        domainFaqs={EDUCATION_DOMAIN_FAQS}
        useCases={EDUCATION_USE_CASES_SEO}
      />
    </div>
  );
}

